import React from 'react';
import { Facebook } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-stone-900 text-white pt-20 pb-10 bg-texture" data-id="element-56">
      <div className="container mx-auto px-4 md:px-6" data-id="element-57">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16 text-center md:text-left" data-id="element-58">
          {/* Brand Column */}
          <div className="md:col-span-1 flex flex-col items-center md:items-start" data-id="element-59">
            <img src="https://cdn.magicpatterns.com/uploads/qtg8rU2C9UAtzRSdRA16ji/copper-stone-logo-transparent.png" alt="Copper & Stone Realty" className="w-48 mb-6" data-id="element-60" />
            <p className="text-brand-silver/80 text-sm mb-6 max-w-xs" data-id="element-61">
              A boutique real estate brokerage serving Broomfield and the north
              Denver metro.
            </p>
            <div className="flex gap-4" data-id="element-62">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-brand-copper transition-colors" data-id="element-63">
                <Facebook size={20} data-id="element-64" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div data-id="element-65">
            <h4 className="text-brand-copper font-serif text-xl mb-6" data-id="element-66">
              Contact
            </h4>
            <address className="not-italic text-brand-silver/80 text-sm space-y-3" data-id="element-67">
              <p data-id="element-68">
                3840 Broadlands Lane
                <br data-id="element-69" />
                Broomfield, CO 80023
              </p>
              <p data-id="element-70">
                <a href="tel:3035475468" className="hover:text-brand-copper transition-colors" data-id="element-71">
                  (303) 547-5468
                </a>
              </p>
              <p data-id="element-72">
                <a href="mailto:hello@copperandstone.com" className="hover:text-brand-copper transition-colors" data-id="element-73">
                  hello@copperandstone.com
                </a>
              </p>
            </address>
          </div>

          {/* Quick Links */}
          <div data-id="element-74">
            <h4 className="text-brand-copper font-serif text-xl mb-6" data-id="element-75">
              Quick Links
            </h4>
            <ul className="text-brand-silver/80 text-sm space-y-3" data-id="element-76">
              <li data-id="element-77">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-78">
                  Find an Agent
                </a>
              </li>
              <li data-id="element-79">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-80">
                  Buyers
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-82">
                  Sellers
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-84">
                  Communities
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-86">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-87">
            <h4 className="text-brand-copper font-serif text-xl mb-6" data-id="element-88">Legal</h4>
            <ul className="text-brand-silver/80 text-sm space-y-3" data-id="element-89">
              <li data-id="element-90">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-91">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-92">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-93">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-94">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-95">
                  DMCA Notice
                </a>
              </li>
              <li data-id="element-96">
                <a href="#" className="hover:text-brand-copper transition-colors" data-id="element-97">
                  Accessibility
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* MLS Disclaimer & Copyright */}
        <div className="border-t border-white/10 pt-8 flex flex-col items-center text-center" data-id="element-98">
          <div className="flex items-center justify-center gap-4 mb-6 opacity-50 grayscale hover:grayscale-0 transition-all" data-id="element-99">
            {/* Placeholder for MLS / Equal Housing logos */}
            <div className="w-12 h-12 border border-white/30 flex items-center justify-center text-[10px] p-1" data-id="element-100">
              EQUAL HOUSING
            </div>
            <div className="w-12 h-12 border border-white/30 flex items-center justify-center text-[10px] p-1" data-id="element-101">
              REALTOR®
            </div>
            <div className="w-16 h-12 border border-white/30 flex items-center justify-center text-[10px] p-1" data-id="element-102">
              MLS GRID
            </div>
          </div>

          <p className="text-brand-silver/50 text-[11px] max-w-4xl mb-4 leading-relaxed" data-id="element-103">
            The data relating to real estate for sale on this web site comes in
            part from the Internet Data Exchange (IDX) program of Colorado Real
            Estate Network, Inc. (CREN), REcolorado, or MLS GRID. Real estate
            listings held by brokerage firms other than Copper & Stone Realty
            are marked with the IDX logo and detailed information about them
            includes the name of the listing brokers. Information deemed
            reliable but not guaranteed.
          </p>

          <p className="text-brand-silver/50 text-xs" data-id="element-104">
            &copy; {new Date().getFullYear()} Copper & Stone Realty. All rights
            reserved. License #12345678.
          </p>
        </div>
      </div>
    </footer>;
}